// src/layouts/AuthLayout.js
import React from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from '../../myNavbar/Navbar';

const AuthLayout = ({ isSidebarOpen, toggleSidebar }) => {
  return (
    <>
      <Navbar isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
      <Outlet />
    </>
  );
};

export default AuthLayout;
